/**
 * The audit trail.
 */

import { request } from './client.js';

// ------------------------------------------------------------------ audit trail

export interface AuditEntry {
  readonly id: string;
  readonly occurred_at: string;
  readonly action: string;
  readonly entity_type: string;
  readonly entity_id: string | null;
  readonly actor_type: string;
  readonly actor_user_id: string | null;
  readonly actor_name: string | null;
  readonly project_id: string | null;
  readonly project_code: string | null;
  readonly reason: string | null;
  readonly before: unknown;
  readonly after: unknown;
  readonly ip: string | null;
}

export interface AuditPage {
  readonly entries: readonly AuditEntry[];
  readonly next_cursor: string | null;
  readonly limited_to_own_projects: boolean;
}

export interface AuditQuery {
  readonly actor?: string;
  readonly project?: string;
  readonly entity_type?: string;
  readonly action?: string;
  readonly from?: string;
  readonly to?: string;
}

function auditQueryString(query: AuditQuery, cursor?: string): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) if (value) params.set(key, value);
  if (cursor) params.set('cursor', cursor);
  const text = params.toString();
  return text ? `?${text}` : '';
}

export function listAudit(query: AuditQuery = {}, cursor?: string): Promise<AuditPage> {
  return request<AuditPage>(`/v1/audit${auditQueryString(query, cursor)}`);
}

/** The href for the CSV. A real link, so the browser downloads it normally. */
export function auditExportUrl(query: AuditQuery = {}): string {
  return `/v1/audit/export${auditQueryString(query)}`;
}
